import { ClaimsGetUseCase } from '../../../application';

export default class ClaimsGetService {
    constructor() {}

    async execute(event) {
        const request = await ClaimsGetUseCase(event);

        return request;
    }
}
